import { render, staticRenderFns } from "./ReCaptchaTerms.vue?vue&type=template&id=9951c540&scoped=true&"
import script from "./ReCaptchaTerms.vue?vue&type=script&lang=js&"
export * from "./ReCaptchaTerms.vue?vue&type=script&lang=js&"
import style0 from "./ReCaptchaTerms.vue?vue&type=style&index=0&id=9951c540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9951c540",
  null
  
)

export default component.exports